exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge[data-v-281c854e] {\r\n    background: red;\n}\r\n", ""]);

// exports
